import Preload from './preload';
import Menu from './menu';
import Game from './game';
import RestartGame from './restart-game';
import InterstitialScene from './interstitial-scene';

const Scenes = [
    Preload,
    Menu,
    Game,
    RestartGame,
    InterstitialScene
]

export default Scenes;